import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class QPTrackingCriteria extends Model.CriteriaBase {
    static typeName = "QPTrackingCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate = DateUtils.monthEnd(DateUtils.add(DateUtils.today(), { months: -1}));

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<QPTrackingCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "QP Tracking Criteria";
    }
}